<template>
  <li class="level-menu outside" @click="openlevelmenu" v-if="checkRole(['agent', 'admin'], ['ccp'])">
    <a class="nav-link" href="#">
      <feather type="airplay"></feather>
      <span>Queue</span>
    </a>
    <ul style="z-index: 20;text-align: left; width: auto;" class="header-level-menu menu-to-be-close"
      :class="{ 'd-block': openLevelmenu }">
      <li @click="$router.push('/queue-management')" v-if="checkRole(['admin'], ['ccp'])" class='clickMenu'>
        <span>Queue Management</span>
      </li>

      <li v-if="checkRole(['admin'], ['ccp'])" style=" border-top: 1px solid #ccc;">
        <span>Report</span>
      </li>
      <li @click="$router.push('/report/queue')" v-if="checkRole(['admin'], ['ccp'])" class='clickMenu'>
        <feather type="corner-down-right"></feather>
        <span>Queue Report</span>
      </li>
    </ul>
  </li>
  <!-- <router-link
          to="/queue-management"
          class="sidebar-link sidebar-title"
          router-link-exact-active 
          v-if="checkRole(['admin'],['ccp'])"
        >
    <li class="level-menu outside" @click="openlevelmenu">
      <a class="nav-link" href="#">
        <feather type="send"></feather>
        <span>Queue</span>
      </a>
    </li>
    </router-link> -->
</template>

<script>
export default {
  name: 'LevelMenu',
  data() {
    return {
      openLevelmenu: false,
    };
  },
  methods: {
    openlevelmenu() {
      this.openLevelmenu = !this.openLevelmenu;
      if (this.openLevelmenu) {
        this.$emit('closeMenu')
      }
    },
    checkRole(role, module) {

      if (role == undefined && module == undefined) {
        return false
      }
      let status_ccp = false
      let status_beacon = false
      let userinfo = localStorage.getItem("userinfo")
      userinfo = JSON.parse(userinfo)
      for (let i = 0; i < module.length; i++) {
        if (module[i] == "beacon") {
          if (userinfo.role_beacon == undefined) {
            status_beacon = false
          }
          status_beacon = role.includes(userinfo.role_beacon);
        }
        else if (module[i] == "ccp") {
          if (userinfo.role_ccp == undefined) {
            status_ccp = false
          }
          status_ccp = role.includes(userinfo.role_ccp);
        }
      }
      return (status_ccp || status_beacon)
    },
  },
};
</script>

<style scoped>
.clickMenu {
  cursor: pointer;
}

.clickMenu:hover {
  color: #2A71FB;
}
</style>
